import { GroupCategory } from "generated/graphql";

export const EDIT_ANIMALS_IN_GROUP_TYPES = {
  ADD_TO_GROUP: "add_to_group",
};

export const GROUP_CATEGORY_OPTIONS = [
  {
    label: "Breeding stock",
    value: GroupCategory.BreedingStock,
  },
  {
    label: "Youngstock",
    value: GroupCategory.Youngstock,
  },
  {
    label: "Culls",
    value: GroupCategory.Culls,
  },
  {
    label: "Pets",
    value: GroupCategory.Pets,
  },
  {
    label: "Terminal",
    value: GroupCategory.Terminal,
  },
  {
    label: "Dairy",
    value: GroupCategory.Dairy,
  },
];

export const BATCH_GENDER_OPTIONS = [
  {
    label: "Male and Female",
    value: "MALE_AND_FEMALE",
  },
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
];
